import { render, staticRenderFns } from "./xiao-hua.vue?vue&type=template&id=78fec6ee&"
import script from "./xiao-hua.vue?vue&type=script&lang=js&"
export * from "./xiao-hua.vue?vue&type=script&lang=js&"
import style0 from "./xiao-hua.vue?vue&type=style&index=0&id=78fec6ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.106.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports